import { Box } from "@mui/material";
import React from "react";

import Tag from "./Tag";
import { derivedBasisTitle, isInheritedBasis } from "./derivedBasis";

export interface DerivedTagProps {
  // What the relation was derived from, as the export words it
  basis?: string | null;
  // "text" runs in a line of text; "chip" stands as a tag on a card
  variant?: "text" | "chip";
}

/**
 * The quiet mark on a relation the pipeline added itself, rather than read
 * as the extraction stated it; its tooltip says on what basis. One inferred
 * from the portfolio or the family of the product reads "likely".
 */
const DerivedTag: React.FC<DerivedTagProps> = ({ basis, variant = "text" }) => {
  const likely = isInheritedBasis(basis);
  const words = likely ? "likely" : "derived";

  if (variant === "chip") {
    return (
      <Tag tone={likely ? "warning" : "default"} italic title={derivedBasisTitle(basis)}>
        {words}
      </Tag>
    );
  }

  return (
    <Box
      component="span"
      title={derivedBasisTitle(basis)}
      sx={{
        color: "text.disabled",
        fontSize: "0.75rem",
        fontStyle: "italic",
        whiteSpace: "nowrap",
      }}
    >
      {words}
    </Box>
  );
};

export default DerivedTag;
